import React, { useEffect, useState } from "react";
import {
  getDocs,
  collection,
  doc,
  getDoc,
  query,
  orderBy,
  setDoc,
  where,
  deleteDoc,
  updateDoc,
  addDoc,
} from "firebase/firestore";
import { db, auth } from "../../firebase";
import "../app.css";
import TrainingsForm from "./TrainingsForm";
import Modal from "react-modal";
import Stack from "@mui/material/Stack";
import Slider from "@mui/material/Slider";
import SentimentSatisfiedAltIcon from "@mui/icons-material/SentimentSatisfiedAlt";
import SentimentVeryDissatisfiedIcon from "@mui/icons-material/SentimentVeryDissatisfied";
import axios from "axios";
import Card from "react-bootstrap/Card";

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
};

Modal.setAppElement("#root");

const marks = [
  {
    value: 1,
    label: "1: Unacceptable",
  },
  {
    value: 2,
    label: "2: Needs Improvement",
  },
  {
    value: 3,
    label: "3: Meets Expectations",
  },
  {
    value: 4,
    label: "4: Exceeds Expectations",
  },
  {
    value: 5,
    label: "5: Outstanding",
  },
];

function HumanResourcesTraining(props) {
  let subtitle;
  const [modalIsOpen, setIsOpen] = React.useState(false);

  function openModal() {
    setIsOpen(true);
  }

  function afterOpenModal() {
    // references are now sync'd and can be accessed.
    subtitle.style.color = "#f00";
  }

  function closeModal() {
    setIsOpen(false);
  }
  // Props
  const selectedUserID = props.selectedUserID;
  // Date Stuff
  const convertDate = (secs) => {
    const output = new Date(secs * 1000);
    return output.toString().slice(3, 15);
  };

  const current = new Date();
  const date = `${
    current.getMonth() + 1
  }/${current.getDate()}/${current.getFullYear()}`;

  console.log("selected user id" + selectedUserID);

  // Get HR Trainings
  const [HRtrainings, setHRtrainings] = useState([]);
  const [gotTrainings, setGotTrainings] = useState(false);
  const [trainingsUpdated, setTrainingsUpdated] = useState(1);
  const getHRtrainings = async () => {
    setHRtrainings([]);
    setGotTrainings(false);
    const q = query(
      collection(db, "hr-trainings"),
      where("employeeID", "==", props.selectedUserID)
    );

    const querySnapshot = await getDocs(q);

    let values = HRtrainings;
    querySnapshot.forEach((doc) => {
      // doc.data() is never undefined for query doc snapshots
      doc.data().status !== "Deleted" &&
      values.push({
        ...doc.data(),
        id: doc.id,
        createdOn: convertDate(doc.data().createdOn.seconds),
      });
    });
    console.log(values);
    setHRtrainings(values);
    setGotTrainings(true);
    console.log(HRtrainings);
  };

  const addComment = async () => {};

  const updateTrainings = async (id, array) => {
    const docRef = doc(db, "hr-trainings", id);
    setDoc(docRef, { replies: array }, { merge: true });
    setTrainingsUpdated(trainingsUpdated + 1);
  };

  const [newTrainingTitleStatus, setNewTrainingTitleStatus] = useState();
  const [trainingID, setTrainingID] = useState();
  const [trainingIterator, setTrainingIterator] = useState();

  const updateTrainingStatus = async (e, newStatus, id, i) => {
    e.preventDefault();
    await updateDoc(doc(db, "hr-trainings", id), {
      status: newStatus,
    });
    HRtrainings[i].status = newStatus;
    setGotTrainings(false);
    getHRtrainings();
    closeModal();
  };

  const [rating, setrating] = React.useState(0);
  const handleChangeRating = (event, newValue) => {
    setrating(newValue);
  };

  const [showReviewRequest, setShowReviewRequest] = useState(false);
  const [reason, setReason] = useState();
  const [showResponseSuccess, setShowResponseSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const sendEmail = async (e) => {
    e.preventDefault();
    setLoading(true);
    axios
      .post(
        "https://sstools-api-d4ca8.uc.r.appspot.com/send-email/licona/request-for-training",
        {
          to: "elpaso_csr@liconainsurance.com",
          cc: ["colt@southernstarmga.com"],
          requester: auth.currentUser.displayName,
          requesterID: auth.currentUser.uid,
          createdOn: new Date().toLocaleString().split(",")[0],
          employeeID: props.selectedUserID,
          employeeName:
            props.selectedUserInfo.first + " " + props.selectedUserInfo.last,
          employeeID: props.selectedUserID,
          reason: reason,
          typeOfTraining,
          comments,
          status: "Incomplete",
        }
      )
      .then(async (response) => {
        // handle success
        const docRef = await addDoc(collection(db, "training-requests"), {
          requester: auth.currentUser.displayName,
          requesterID: auth.currentUser.uid,
          createdOn: new Date(),
          employeeID: props.selectedUserID,
          employeeName:
            props.selectedUserInfo.first + " " + props.selectedUserInfo.last,
          employeeID: props.selectedUserID,
          reason: reason,
          typeOfTraining,
          comments,
          status: "Incomplete",
        });
      })
      .then(() => {
        setLoading(false);
        setReason();
        setTypeOfTraining();
        setComments();
        setShowResponseSuccess(true);
      })
      .catch(function (error) {
        // handle error
        console.log(error);
      })
      .finally(function () {
        // always executed
      });
  };

  const [comments, setComments] = useState();
  const [typeOfTraining, setTypeOfTraining] = useState();

  const [trainingRequestsList, setTrainingRequestsList] = useState([]);
  const [gotTrainingRequests, setGotTrainingRequests] = useState(false);
  const getTrainingRequests = async () => {
    console.log("Getting Training Requests");
    setGotTrainingRequests(false);

    const q = query(
      collection(db, "training-requests")
      // where("employee", "==", props.userID)
    );
    const queryData = await getDocs(q);
    setTrainingRequestsList(
      queryData.docs.map((doc) => ({ ...doc.data(), id: doc.id }))
    );
    setGotTrainingRequests(true);
  };
  const deleteTrainingRequests = async (docID) => {
    let verify = prompt(
      "You are about to delete a Training Request! If you are sure, type DELETE below: "
    );
    if (verify === "DELETE") {
      await deleteDoc(doc(db, "training-requests", docID));
      getTrainingRequests();
      // Log System Activity
      await addDoc(collection(db, "system-activity"), {
        activityDate: new Date(),
        authorID: auth.currentUser.uid,
        authorName: auth.currentUser.displayName,
        description:
          "A training request was deleted by: " + auth.currentUser.displayName,
      });
    }
  };

  useEffect(() => {
    !gotTrainings && getHRtrainings();
    !gotTrainingRequests && getTrainingRequests();
  }, [selectedUserID, gotTrainings, trainingsUpdated]);

  return (
    <section>
      {trainingRequestsList.map((trainingRequests, i) => {
        if (trainingRequests.status === "Incomplete" && props.userInfo.admin)
          if (!trainingRequests.dismissedByUser)
            return (
              <li key={"trainingRequests" + i} className="mb-3">
                <Card>
                  <Card.Header className="bg-red-300">
                    <span className="font-bold text-lg">Training Request </span>
                    {trainingRequests.authorName}{" "}
                  </Card.Header>
                  <Card.Body>
                    <Card.Text>
                      <p className="mt-2">
                        A training request was submitted for{" "}
                        {trainingRequests.employeeName} by Supervisor{" "}
                        {trainingRequests.requester}:
                      </p>
                      <div className="ml-5">
                        <p>
                          Reason: <i>{trainingRequests.reason}</i>
                        </p>
                        <p>
                          Type Of Training:{" "}
                          <i>{trainingRequests.typeOfTraining}</i>
                        </p>
                        <p>
                          Comments: <i>{trainingRequests.comments}</i>
                        </p>
                      </div>
                      <p className="my-2">
                        Dismissing this notification will not mark the request
                        as complete, it will only hide the notification.
                      </p>
                      <button
                        onClick={async (e) => {
                          await updateDoc(
                            doc(db, "training-requests", trainingRequests.id),
                            {
                              status: "Complete",
                            }
                          );
                          getTrainingRequests();
                        }}
                        className="mt-2 rounded py-2 px-3 bg-sky-600 hover:bg-sky-900 text-white font-[600]"
                      >
                        Mark As Complete
                      </button>
                    </Card.Text>
                  </Card.Body>
                  {props.userInfo.admin && (
                    <Card.Footer>
                      <button
                        onClick={(e) =>
                          deleteTrainingRequests(trainingRequests.id)
                        }
                        className="text-red-600"
                      >
                        Delete This Request
                      </button>
                    </Card.Footer>
                  )}
                </Card>
              </li>
            );
      })}
      <h1 className="text-2xl font-bold text-red-900">Add Employee Training</h1>
      <div className="p-3">
        {/* Review Request */}
        {props.userInfo.supervisor && (
          <div className="card mb-3">
            <div className="card-header">
              <button
                onClick={(e) => setShowReviewRequest(!showReviewRequest)}
                className="text-lg text-sky-600 font-bold"
              >
                Request Training
              </button>
            </div>
            {showReviewRequest && (
              <>
                {showResponseSuccess ? (
                  <div className="card-body">
                    <div>
                      <p className="text-green-600 font-bold text-xl">
                        Request successfully sent.
                      </p>
                      <button
                        onClick={(e) => setShowResponseSuccess(false)}
                        className="mt-2 text-sky-600"
                      >
                        Return To Request Menu
                      </button>
                    </div>
                  </div>
                ) : (
                  <div className="card-body">
                    <form onSubmit={(e) => sendEmail(e)}>
                      <p className="text-lg font-medium">Type of Training:</p>
                      <input
                        type="text"
                        required
                        value={typeOfTraining}
                        onChange={(e) => setTypeOfTraining(e.target.value)}
                        className="w-full rounded mb-2"
                        placeholder="Type of Training"
                      />
                      <p className="text-lg font-medium">
                        Reason for Training:
                      </p>
                      <textarea
                        required
                        value={reason}
                        onChange={(e) => setReason(e.target.value)}
                        className="w-full rounded mb-2"
                        placeholder="Reason"
                      ></textarea>
                      <p className="text-lg font-medium">
                        Additional Comments:
                      </p>
                      <textarea
                        required
                        value={comments}
                        onChange={(e) => setComments(e.target.value)}
                        className="w-full rounded mb-2"
                        placeholder="Ex: Have a particular training in mind?"
                      ></textarea>
                      <button
                        disabled={loading}
                        type="submit"
                        className="font-medium text-white m-1 px-2 py-1 rounded bg-green-900 hover:bg-green-700"
                      >
                        {!loading ? <>Send Request</> : <>Sending....</>}
                      </button>
                    </form>
                  </div>
                )}
              </>
            )}
          </div>
        )}
        <TrainingsForm
          setHRtrainings={setHRtrainings}
          setGotTrainings={setGotTrainings}
          selectedUserID={selectedUserID}
          trainingsUpdated={trainingsUpdated}
          setTrainingsUpdated={setTrainingsUpdated}
        />
      </div>
      <ul className="list mt-3">
        {gotTrainings === true && (
          <>
            <h1 className="text-2xl font-bold text-red-900">
              Training History
            </h1>
            <div className="p-3">
              {HRtrainings.map((trainings, i) => (
                <div key={"trainings-container" + i} className="mb-3 card">
                  <div className="card-header text-lg">
                    <button
                      onClick={(e) => {
                        HRtrainings[i].hideOnList = !HRtrainings[i].hideOnList;
                        setTrainingsUpdated(trainingsUpdated + 1);
                      }}
                      className="font-bold mr-5 text-sky-600 capitalize"
                    >
                      {trainings.newTrainingTitle} on{" "}
                      {convertDate(trainings.trainingDate.seconds)} at{" "}
                      {trainings.trainingLocation}
                    </button>
                  </div>
                  {HRtrainings[i]?.hideOnList ? (
                    <></>
                  ) : (
                    <div className="card-body text-lg">
                      {/* Training Title */}
                      <div className="card">
                        <div className="card-header">
                          <h3 className="font-bold">Title</h3>
                        </div>
                        <div className="card-body">
                          <p className="block px-11">
                            {trainings?.newTrainingTitle}
                          </p>
                        </div>
                      </div>
                      {/* Training Location */}
                      <div className="card mt-3">
                        <div className="card-header">
                          <h3 className="font-bold">Location</h3>
                        </div>
                        <div className="card-body">
                          <p className="block px-11">
                            {trainings?.trainingLocation}
                          </p>
                        </div>
                      </div>
                      {/* Training Date */}
                      <div className="card mt-3">
                        <div className="card-header">
                          <h3 className="font-bold">Date</h3>
                        </div>
                        <div className="card-body">
                          <p className="block px-11">
                            {convertDate(trainings?.trainingDate.seconds)}
                          </p>
                        </div>
                      </div>
                      {/* Rating */}
                      <div className="card mt-3">
                        <div className="card-header">
                          <h3 className="font-bold">Rating</h3>
                        </div>
                        <div className="card-body">
                          <p className="mx-auto text-center">
                            Rating: {trainings?.rating}
                          </p>
                          <Stack
                            spacing={2}
                            direction="row"
                            sx={{ mb: 1 }}
                            alignItems="center"
                          >
                            <SentimentVeryDissatisfiedIcon />
                            <Slider
                              disabled
                              aria-label="Rating"
                              defaultValue={1}
                              value={trainings?.rating}
                              onChange={handleChangeRating}
                              valueLabelDisplay="auto"
                              note={1}
                              marks={marks}
                              min={1}
                              max={5}
                            />
                            <SentimentSatisfiedAltIcon />
                          </Stack>
                        </div>
                      </div>
                      {/* Notes */}
                      <div className="card mt-3">
                        <div className="card-header">
                          <h3 className="font-bold">Notes:</h3>
                        </div>
                        <div className="card-body">
                          <ol className="list-decimal pl-10">
                            {trainings?.notes.map((note, i) => {
                              return (
                                <>
                                  <li className="test rounded shadow-md m-3">
                                    {note.description}
                                  </li>
                                </>
                              );
                            })}
                          </ol>
                        </div>
                      </div>
                      {/* Supervisor Comments */}
                      <div className="card mt-3">
                        <div className="card-header">
                          <h3 className="font-bold">Supervisor Comments:</h3>
                        </div>
                        <div className="card-body">
                          <ol className="list-decimal pl-10">
                            {trainings?.supervisorComments.map(
                              (supervisorComment, i) => {
                                return (
                                  <>
                                    <li className="test rounded shadow-md m-3">
                                      {supervisorComment.description}
                                    </li>
                                  </>
                                );
                              }
                            )}
                          </ol>
                        </div>
                      </div>
                      {/* Training Comments */}
                      <div className="card mt-3">
                        <div className="card-header">
                          <h3 className="font-bold">Training Comments:</h3>
                        </div>
                        <div className="card-body">
                          <ol className="list-decimal pl-10">
                            {trainings?.trainingComments.map(
                              (trainingComment, i) => {
                                return (
                                  <>
                                    <li className="test rounded shadow-md m-3">
                                      {trainingComment.description}
                                    </li>
                                  </>
                                );
                              }
                            )}
                          </ol>
                        </div>
                      </div>

                      <hr className="my-3" />
                      {/* Comment List */}
                      <h3 className="font-bold mt-2">Comments:</h3>
                      <ul className="list ml-2">
                        {trainings.replies?.map((reply, iterator) => {
                          return (
                            <>
                              {!reply.reply ? (
                                <></>
                              ) : (
                                <li
                                  className="test rounded shadow-md m-3"
                                  key={"reply" + iterator}
                                >
                                  <p className="italic">
                                    {reply.sender} on {reply.date}:
                                  </p>
                                  <p className="block">{reply.reply}</p>
                                  {auth.currentUser.uid === reply.createdBy && (
                                    <>
                                      <button
                                        onClick={() => {
                                          HRtrainings[i].replies.splice(
                                            iterator,
                                            1
                                          );
                                          updateTrainings(
                                            trainings.id,
                                            HRtrainings[i].replies
                                          );
                                        }}
                                        className="text-xs m-1 text-red-900"
                                      >
                                        Delete Comment
                                      </button>
                                    </>
                                  )}
                                </li>
                              )}
                            </>
                          );
                        })}
                      </ul>

                      {/* Add Reply */}
                      <div className="ml-2">
                        <hr className="my-2" />
                        <input
                          id={"reply" + i}
                          type="text"
                          className="border-2 border-red-900 p-1 w-full rounded"
                          placeholder="Enter your reply here..."
                        />
                        <button
                          onClick={(e) => {
                            HRtrainings[i].replies.push({
                              date: date,
                              reply: document.getElementById("reply" + i).value,
                              sender: auth.currentUser.displayName,
                              createdBy: auth.currentUser.uid,
                            });
                            updateTrainings(
                              trainings.id,
                              HRtrainings[i].replies
                            );
                            document.getElementById("reply" + i).value = "";
                          }}
                          className="block font-medium text-white my-1 px-2 py-1 rounded bg-green-900 hover:bg-green-700"
                        >
                          Add Comment
                        </button>
                      </div>
                      <hr />
                      {props.userInfo.admin && (
                        <>
                          <button
                            onClick={(e) => {
                              updateTrainingStatus(
                                e,
                                "Deleted",
                                trainings.id,
                                i
                              );
                            }}
                            className="m-1 text-red-900"
                          >
                            Delete This Training
                          </button>
                        </>
                      )}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </>
        )}
      </ul>
      {/* Modals */}
      <Modal
        isOpen={modalIsOpen}
        onAfterOpen={afterOpenModal}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel="Training Status Modal"
      >
        <div className="min-w-[200px] p-3">
          <p className="mb-2 font-medium text-lg text-red-900">New Status:</p>
          <form
            onSubmit={(e) =>
              updateTrainingStatus(
                e,
                newTrainingTitleStatus,
                trainingID,
                trainingIterator
              )
            }
          >
            <select
              required
              value={newTrainingTitleStatus}
              onChange={(e) => setNewTrainingTitleStatus(e.target.value)}
              className="w-full"
            >
              <option value="In Progress">In Progress</option>
              <option value="Delayed">Delayed</option>
              <option value="Achieved">Achieved</option>
            </select>
            <div>
              <button
                type="submit"
                className="block w-full mx-auto font-medium text-white mt-3 p-2 rounded bg-green-900 hover:bg-green-700"
              >
                Update Status
              </button>
              <button
                onClick={(e) => {
                  closeModal();
                  setTrainingID();
                  setTrainingIterator();
                  setNewTrainingTitleStatus();
                }}
                className="block w-full mx-auto font-medium text-white mt-3 p-2 rounded bg-red-900 hover:bg-red-700"
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </Modal>
    </section>
  );
}

export default HumanResourcesTraining;
